import type { IconGlyph } from '../icon';

import { iconReportThick } from './report-thick';

/**
 * Tractie `report` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/report.jsx`.
 * Verbatim copy of the SVG `d` attributes, 3 paths in source order.
 */
export const iconReport: IconGlyph = {
  name: 'report',
  path: [
    'M7.53 7h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5m7 2h-7c-.28 0-.5.22-.5.5s.22.5.5.5h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5m-2 3h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5',
    'M18.03 16V3.5c0-.83-.67-1.5-1.5-1.5h-11c-.83 0-1.5.67-1.5 1.5v15c0 .83.67 1.5 1.5 1.5h8.5zm-4 2.59V16h2.59zm-1 .41h-7.5c-.28 0-.5-.22-.5-.5v-15c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5V15h-4z',
    'M19.03 4.09V20.5c0 .28-.22.5-.5.5H6.12c.21.58.76 1 1.41 1h11c.83 0 1.5-.67 1.5-1.5v-15c0-.65-.42-1.21-1-1.41',
  ],
  selected: iconReportThick,
};
